<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-large"
    title="VNコネクト設定未完了一覧"
  >
    <template v-slot:body="{ cancel }">
      <!-- BODY -->
      <v-card-text class="pa-0">
        <div class="modal-body">
          <v-container>
            <v-row>
              <v-col class="d-flex flex-row justify-end mb-2">
                <v-btn color="primary" @click="resetting"
                  >VNコネクト再設定</v-btn
                >
              </v-col>
            </v-row>
            <v-alert v-if="alertMsg" class="my-2" :text="alertMsg"></v-alert>
            <app-table
              primary-key="saseGatewayAct.wnumber"
              :fields="vnConnects.fields"
              :items="sortedSaseGatewayList"
              :selectable="true"
              v-model="vnConnects.selected"
              :hover="true"
              :per-page="-1"
            >
              <template #cell(vpnVnCode)="{ item }">
                {{
                  item.saseGatewayVnConnectCommon.vpnVnCode.startsWith("D")
                    ? `${item.saseGatewayVnConnectCommon.vpnVnCode}(L3)`
                    : item.saseGatewayVnConnectCommon.vpnVnCode
                }}
              </template>
              <template #cell(vnConnectName)="{ item }">
                {{ item.saseGatewayVnConnectAct.vnConnectName }}<br />
                {{ item.saseGatewayVnConnectSby.vnConnectName }}
              </template>
              <template #cell(wnumber)="{ item }">
                {{ item.saseGatewayVnConnectAct.wnumber }}<br />
                {{ item.saseGatewayVnConnectSby.wnumber }}
              </template>
              <template #cell(saseGatewayServiceType)="{ item }">
                {{
                  $filter.enumTo(
                    item.saseGatewayVnConnectCommon.saseGatewayServiceType,
                    "saseGatewayServiceType"
                  )
                }}
              </template>
            </app-table>
          </v-container>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <!-- FOOTER -->
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn @click="cancel" variant="outlined" color="primary"
              >戻る</v-btn
            >
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import { VueFinalModal } from "vue-final-modal";
import type { AppTableHeader } from "@/components/AppTable.vue";
import type {
  SaseGatewayResetting,
  SaseGatewayResettingItem,
} from "@/apis/SaseGatewayResettingApi";
import cloneDeep from "lodash/cloneDeep";

export default defineComponent({
  name: "SaseGatewayResettingList",
  props: {
    /** VNコネクト設定未完了一覧情報 */
    saseGatewayResetting: {
      type: Object as PropType<SaseGatewayResetting>,
      required: true,
    },
  },
  data() {
    return {
      vnConnects: {
        fields: [
          {
            key: "vpnVnCode",
            title: "接続先VPN/VNコード",
            width: "180px",
          },
          {
            key: "vnConnectName",
            title: "VNコネクト名(Act/Sby)",
            width: "180px",
          },
          {
            key: "wnumber",
            title: "VNコネクト番号(Act/Sby)",
            width: "180px",
          },
          {
            key: "saseGatewayServiceType",
            title: "タイプ",
            width: "150px",
          },
        ] as AppTableHeader<SaseGatewayResetting>[],
        selected: [] as SaseGatewayResettingItem[],
      },
      alertMsg: null as string | null,
    };
  },
  computed: {
    /**
     * VNコネクト番号(Act)の降順でソート
     */
    sortedSaseGatewayList(): SaseGatewayResettingItem[] {
      return cloneDeep(this.saseGatewayResetting.saseGatewayList).sort(
        (a, b) => {
          if (
            a.saseGatewayVnConnectAct.wnumber >
            b.saseGatewayVnConnectAct.wnumber
          ) {
            return -1;
          } else if (
            a.saseGatewayVnConnectAct.wnumber <
            b.saseGatewayVnConnectAct.wnumber
          ) {
            return 1;
          }
          return 0;
        }
      );
    },
  },
  methods: {
    /** VNコネクト再設定 */
    async resetting() {
      if (this.vnConnects.selected.length !== 1) {
        this.alertMsg = "VNコネクトを１つ選択してください。";
        return;
      }
      this.alertMsg = null;

      const selectedItem = this.vnConnects.selected[0];

      const saseGatewayServiceType =
        selectedItem.saseGatewayVnConnectCommon.saseGatewayServiceType;

      await this.$confirm(
        `${this.$filter.enumTo(saseGatewayServiceType, "saseGatewayServiceType")}のVNコネクト再設定を行います。よろしいですか？`
      );

      await this.$api.saseGatewayResetting.postSaseGatewayResetting(
        selectedItem.saseGatewayVnConnectAct.wnumber
      );
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },
  },
});
</script>
